<template>
  <section
    :class="[
      'related-field__cards',
      { 'article-list': isList },
      { 'article-page': isUsedInArticle },
      { 'article-artwork': linkPath === 'artwork' },
    ]"
  >
    <div
      class="related-field__card"
      v-for="(card, index) in cards"
      :key="index"
    >
      <ArticleFavourite v-if="hasFavourite" :favouriteId="card.favourite_id" />

      <a
        :href="externalLink"
        target="_blank"
        v-if="isExternal"
        :title="`[前往]${card.hasOwnProperty('name') ? card.name : card.title}`"
      >
        <div class="related-field__card__cover">
          <img
            class="related-field__card__cover-image"
            style="opacity: 1;"
            :src="card.cover_image_url"
            :alt="''"
          />
          <!-- 暫時隱藏 lazy-loading -->
          <!-- <img
            class="related-field__card__cover-image lazyload"
            :data-reference="card.cover_image_url"
            :alt="''"
          />-->
          <noscript>
            <img
              class="related-field__card__cover-image"
              style="opacity: 1;"
              :src="card.cover_image_url"
              :alt="''"
            />
          </noscript>
        </div>
        <h3>{{ card.hasOwnProperty('name') ? card.name : card.title }}</h3>
      </a>
      <router-link
        :to="{ name: linkPath, params: { articleId: card.id } }"
        v-if="!isExternal"
        :title="`[前往]${card.hasOwnProperty('name') ? card.name : card.title}`"
      >
        <div class="related-field__card__cover">
          <img
            class="related-field__card__cover-image"
            style="opacity: 1;"
            :src="card.cover_image_url"
            :alt="''"
          />
          <!-- 暫時隱藏 lazy-loading -->
          <!-- <img
            class="related-field__card__cover-image lazyload"
            :data-reference="card.cover_image_url"
            :alt="''"
          />-->
          <noscript>
            <img
              class="related-field__card__cover-image"
              style="opacity: 1;"
              :src="card.cover_image_url"
              :alt="''"
            />
          </noscript>
        </div>

        <div class="related-field__card__temple" v-if="linkPath === 'artwork'">
          <img src="@/assets/images/header/house_new.svg" alt="" />
          <div>
            <p v-if="card.related_temple">{{ card.related_temple }}</p>
            <p v-else-if="checkHasRelatedTemple(card.related_temples)">{{
              card.related_temples[0].name
            }}</p>
            <p v-else>--</p>
            <p>{{ card.space || '--' }}</p>
          </div>
        </div>

        <h3>{{ card.hasOwnProperty('name') ? card.name : card.title }}</h3>

        <p class="related-field__card__description" v-if="hasDescription">
          {{ getAccurateDescription(card) }}
        </p>
      </router-link>
    </div>
    <slot></slot>
  </section>
</template>

<script>
import ArticleFavourite from '@/components/article/ArticleFavourite';

export default {
  name: 'HeroCards',
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    linkPath: {
      type: String,
      default: '',
    },
    isList: {
      type: Boolean,
      default: false,
    },
    isExternal: {
      type: Boolean,
      default: false,
    },
    externalLink: {
      type: String,
      default: '#',
    },
    hasDescription: {
      type: Boolean,
      default: true,
    },
    isUsedInArticle: {
      type: Boolean,
      default: false,
    },
    hasFavourite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    isHomePath() {
      return this.$route.path === '/';
    },
  },
  methods: {
    checkHasRelatedTemple(relatedTemples) {
      if (
        !Array.isArray(relatedTemples) ||
        !relatedTemples.length ||
        !relatedTemples[0].hasOwnProperty('name')
      )
        return false;

      return true;
    },
    getAccurateDescription(article) {
      const isArticleExisted =
        typeof article === 'object' && Object.keys(article).length;

      // early return if no data or no key to check
      if (!this.linkPath || !isArticleExisted) return;

      switch (this.linkPath) {
        case 'artwork': {
          // 在標籤結果頁
          if (article.content) {
            return article.content;
          }

          // 在其他頁面時
          if (!Array.isArray(article.paragraphs) || !article.paragraphs.length)
            return;

          return article.paragraphs[0].content;
        }

        case 'temple': {
          if (!article.description) return;

          return article.description;
        }

        case 'theme': {
          // 在首頁時
          if (this.isHomePath) {
            return article.content;
          }

          // 在其他頁面時
          if (!Array.isArray(article.contents) || !article.contents.length)
            return;

          return article.contents[0].reference
            ? article.contents[0].reference.content
            : '';
        }
      }
    },
  },
  components: {
    ArticleFavourite,
  },
};
</script>

<style lang="scss" scoped>
.related-field {
  a {
    display: block;
  }

  &__cards {
    @include for-tablet {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: wrap;
      max-width: 605px;
      margin: auto;
      &::after {
        width: 33%;
        content: '';
      }
    }
  }

  &__card {
    position: relative;
    flex: 0 1 auto;
    border-bottom: 1px solid $color-light-border;
    width: 280px;
    margin-left: 0;
    margin-bottom: 40px;

    @include for-desktop {
      margin-left: 0;
      margin-right: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &__cover {
      position: relative;
      width: 280px;
      margin: 0px auto;
      font-size: 0;
    }

    &__cover-image {
      height: 210px;
      min-height: 200px;
      width: 100%;
      object-fit: cover;
      object-position: top;
      opacity: 0;
      transition: opacity 600ms ease-in;
    }

    h3 {
      /* 列表卡片標題 */
      position: relative; /* 為了不被卡片陰影遮住 */
      font-size: 1.375rem;
      letter-spacing: 1.22px;
      line-height: 1.5;
      margin: 0 auto;
      width: 280px;
      color: $color-light-title;
      font-weight: 500;
      padding: 12px 0;
      text-align: left;
      @include truncate-string(100%);

      @include for-desktop {
        width: 100%;
        max-width: 300px;
      }
    }

    &__description {
      font-size: 1.25rem;
      line-height: 1.5;
      letter-spacing: 1.5px;
      margin: 0 auto 10px;
      color: $color-light-description;
      text-align: justify;
      min-height: 96px;
      @include truncate-multiple-lines(4, 100%);
    }

    &__temple {
      display: flex;
      align-items: center;
      margin: 10px auto 0;
      img {
        margin-right: 6px;
      }
      p {
        color: $color-light-title;
        margin: 0;
        font-weight: 500;
        text-align: left;
        @include truncate-string(250px);
        &:first-child {
          margin-bottom: 4px;
        }
      }
    }
  }
}

.article-list {
  @include for-desktop {
    max-width: 930px;
  }
  &.related-field__cards {
    @include for-desktop {
      justify-content: flex-start;
    }
  }
  .related-field__card {
    margin-left: auto;
    margin-right: auto;

    @include for-tablet {
      margin-left: 0;
      margin-right: 0;
    }

    @include for-desktop {
      margin-left: 45px;

      &:nth-child(3n + 1) {
        margin-left: 0;
      }
    }
  }
}

.article-artwork {
  h3 {
    color: $color-light-paragraph;
  }
}

.article-page {
  @include for-tablet {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
